import { UnitSimOperation } from "@/store/flowsheet/flowsheet.slice"
import { memo, useEffect } from "react"
import { EventMap, getEventBusInstance } from "../../events/useEventBusInstance"

export const NodeSimUpdate = memo(({cellMap}: {cellMap: {[key: string]: UnitSimOperation}}) => {

  useEffect(() => {
    return () => {
      const eventBus = getEventBusInstance();
      eventBus.trigger(EventMap.nodeSimStateChange, {changes: {}})
    }
  }, [])

  useEffect(() => {
    const eventBus = getEventBusInstance();
    setTimeout(() => {
      eventBus.trigger(EventMap.nodeSimStateChange, { changes:cellMap})
    }, 200);
  }, [cellMap])

  return null;
})